var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 3.9h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9H8V2.1h1.8v1.8h5.4V2.1H17zm-1.8 1.8H9.8v1.8H8V5.7H5.3v3.6h14.4V5.7H17v1.8h-1.8zm4.5 5.4H5.3v7.2h14.4z"
  })));
};
export default SvgCalendar;